import { find, forEach, get, reverse } from 'lodash-es';

import { updateMenuState } from './menu.utils';
import { menuConditions } from './config.menuconditions';

export const getMenu = ({ questionnaire }) => {
  const menu = get(questionnaire, 'description.menuConfig', []);

  return menu;
};

const getMenuConditions = ({ menu }) => {
  const newMenuConditions = [menuConditions.closed];

  forEach(reverse([...menu]), step => {
    let code = step.code;

    if (step.code === 'quotations' && find(menu, { code: 'loans' })) {
      code = `${step.code}Loans`;
    }
    if (step.code === 'generalData' && find(menu, { code: 'extra_data' })) {
      code = `${step.code}ExtraData`;
    }

    if (menuConditions[step.code]) {
      newMenuConditions.push({ ...menuConditions[code], sequence: newMenuConditions.length + 1 });
    }
  });

  return newMenuConditions;
};

export const updateMenuFromConfig = ({ salesroute, quotation, questionnaireSalesRoute, menu, onlyState }) => {
  const menuConditions = getMenuConditions({ menu: getMenu({ questionnaire: questionnaireSalesRoute }) });

  for (let i = 0; i < menuConditions.length; i++) {
    const condition = menuConditions[i];

    if (
      condition.condition &&
      condition.data &&
      condition.condition({ srStatus: get(salesroute, 'status'), salesroute, quotation, questionnaireSalesRoute })
    ) {
      return updateMenuState(condition.data({ menu, onlyState }));
    }
  }

  return menu;
};

export const getNextMenu = ({ menu, current }) => get(find(menu, { code: current }), 'next');
